<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تفاصيل الخطأ</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/errorlogs">سجل الأخطاء</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تفاصيل الخطأ</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="text-center pt-3">
          <errorAlert v-if="hasError" :alertMessage= "message" />
        </div>
        <div v-if="isLoading" class="text-center">
          <mainLoader  />
        </div>
        <div v-else class="row mb-4 mt-5">
          <div class="col">
            <div class="table-responsive" dir="ltr">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <th>User Id</th>
                    <td>{{ items.userId }}</td>
                  </tr>
                  <tr>
                    <th>Error Number</th>
                    <td>{{ items.errorNum }}</td>
                  </tr>
                  <tr>
                    <th>Error</th>
                    <td>{{ items.message }}</td>
                  </tr>
                  <tr>
                    <th>Details</th>
                    <td>{{ items.details }}</td>
                  </tr>
                  <tr>
                    <th>Created At</th>
                    <td>{{ items.createdAt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name: "errorview",
  data(){
    return{
      errorId: this.$route.params.key,
      hasError: false,
      isLoading: false,
      message: "",
      items: {},
    }
  },
  methods:{
    getData() {
      this.isLoading = true;
      this.$http.get(`/api/admin/errorLogs/retrieve/${this.errorId}`).then(res => {
        // console.log(res);
        this.isLoading = false;
        this.items = res.data.errorLog;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    }
  },
  created() {
    this.getData();
  }
}
</script>